import React, { useState, useEffect } from "react";
import Icon from "react-icons-kit";
import DownloadState from "./DownloadState";
import { ic_info } from "react-icons-kit/md/ic_info";

const UpgradeDownloadModal = ({
  breakingChanges,
  triggerDownloadModal,
  upgradeVersion,
  setUpgradeVersion,
  fileNames
}) => {
  const [screen, setScreen] = useState(1);
  const [isHotfix, setIsHotfix] = useState(false);

  useEffect(() => {
    console.log(upgradeVersion);
    if (upgradeVersion.split(".").length === 4) {
      setIsHotfix(true);
    } else {
      setIsHotfix(false);
    }
  }, [upgradeVersion, setUpgradeVersion]);

  const setLink = url => {
    let link = document.createElement("a");
    link.setAttribute("download", null);
    // link.setAttribute("target", "_blank");
    // link.setAttribute("rel", "noopener noreferrer");
    link.style.display = "none";
    document.body.appendChild(link);
    link.setAttribute("href", url);
    link.click();
    document.body.removeChild(link);
  };

  const downloadFile = (type, version, filename) => {
    if (type === 1) {
      const url = `https://migrations.izenda.com/Static/Files/${version}/${filename}`;
      setLink(url);
    }
    if (type === 2) {
      const url = `https://migrations.izenda.com/Static/Files/hotfixes/${version}/${filename}`;
      setLink(url);
    }
  };

  return (
    <div className="modalpopup_custom">
      {screen === 2 ? (
        <div className="page-modal dm-modal">
          <div className="not_icons">
            <span className="ic_info">
              <Icon size={150} icon={ic_info} />
            </span>
          </div>
          <div className="not_head_wrapper breaking_changes">
            <div className="break_txt">Breaking Changes</div>
            <p className="break_help_txt">
              Upgrading to {upgradeVersion} from your previous version may
              potentially cause some components to fail.
            </p>
          </div>
          <div
            dangerouslySetInnerHTML={{
              __html: breakingChanges.replace("¶", "")
            }}
          />

          <div className="act_btn">
            <button className="btn_ok" onClick={triggerDownloadModal}>
              OK
            </button>
          </div>
        </div>
      ) : null}
      {screen === 1 ? (
        <div className="page-modal">
          <div className="row">
            <div className="col-sm-6 top_head">
              Downloading {upgradeVersion}
            </div>
            <div className="col-sm-6 crossTop" onClick={triggerDownloadModal}>
              X
            </div>
          </div>
          <div className="row">
            <div className="heading">
              Download each file by selecting the download icon next to the file
              name
            </div>
            <div className="middleContainer">
              <div className="col-sm-7 leftOptions">
                {fileNames &&
                  fileNames.length > 0 &&
                  fileNames
                    .filter(val => val.includes(".zip"))
                    .map((val, index) => {
                      return (
                        <div key={index}>
                          <DownloadState
                            upgradeVersion={upgradeVersion}
                            downloadFile={downloadFile}
                            val={val}
                          />
                        </div>
                      );
                    })}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="buttonArea">
              <button
                type="button"
                className="btn btn-info margin-right"
                onClick={triggerDownloadModal}
              >
                Done
              </button>
            </div>
          </div>
          {!isHotfix && (
            <div className="ScheMigHelpTxt">
              Download Schema Migration Scripts{" "}
              <a href="https://migrations.izenda.com/" target="_blank">
                here
              </a>
            </div>
          )}
        </div>
      ) : null}
    </div>
  );
};

export default UpgradeDownloadModal;



// WEBPACK FOOTER //
// ./src/components/Profile/UpgradeComponent/UpgradeDownloadModal.js